import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  type ListPendingParams,
  type PendingConfirmationPage,
} from "../../../domain/entities/pending-confirmation";
import { type PendingConfirmationDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listPending = createAsyncThunk<
  PendingConfirmationPage,
  ListPendingParams,
  { dispatch: PendingConfirmationDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_PENDING, async (params, { extra }) => {
  return await extra.contactCenterRepo.listPending(params);
});
